<template>
    <el-drawer
        title="调整数据"
        :visible.sync="drawerShow"
        :wrapperClosable="false"
        :destroy-on-close="true"
        size="auto"
        @close="close"
    >
        <div class="drawer-content">			
            <el-form
                :model="formDatas"
                :rules="rules"
                ref="formDatas"
                label-position="top"
                class="MT10"
            >
				<el-form-item v-if="itemData && itemData.ticketName">
				    <span slot="label">当前票品:</span>
				    {{ itemData && itemData.ticketName }}  <span class="ML10">￥{{itemData && itemData.sellPrice}}</span>
				</el-form-item>
				<el-form-item>
					<el-table						
					    v-if="itemData"
					    :data="[1]"
					    style="width: 100%"
					    size="small"
					    border
					    header-row-class-name="page-list-table"
					>
					    <el-table-column label="总库存">
					        <template>{{ itemData.totalNum }}</template>
					    </el-table-column>
					    <el-table-column label="已销售">
					        <template>{{itemData.sellNum + itemData.successCount}}</template>
					    </el-table-column>
					    <el-table-column label="待支付">
					        <template>{{itemData.occupyNum}}</template>
					    </el-table-column>
					    <el-table-column label="剩余可售">
					        <template><span :class="itemData.leftNum < 0 ? 'color-danger' : ''">{{itemData.leftNum}}</span></template>
					    </el-table-column>
						<el-table-column label="候补库存">
						    <template>{{itemData.altLeftNum}}</template>
						</el-table-column>
						<el-table-column label="候补中">
						    <template>{{itemData.amidCount}}</template>
						</el-table-column>
						<el-table-column label="缺票">
						    <template>{{itemData.lackTicketsNum}}人</template>
						</el-table-column>
					</el-table>					
				</el-form-item>               
                <el-form-item prop="num" label="调整销售票数:">
                    <el-input-number style="width:100%" v-model="formDatas.adjustSellNum" :precision="0" controls-position="right" :min="0" :max="5000" size="medium"  placeholder="请输入调整数量"></el-input-number>
                </el-form-item>
				<div class="color-danger">
					<p>1. 0表示不修改销售票数，经营平台统计和展示真实销售数</p>
					<p>2. 非0整数修改经营平台销售票数展示，销售额也将按调整后销售票数计算展示</p>
					<p>3. 调整后的销售额将按照当前票档价格计算</p>
					<p>4. 调整后的销售票数只影响经营平台演出列表的销售票数、销售额的展示，订单、结算仍然按照真实数据处理，不受影响</p>
				</div>				
            </el-form>            
        </div>
        <div class="drawer-footer">
            <el-button @click="close">取消</el-button>
            <el-button type="primary" @click="submitForm()" :loading="btnLoading"
                >确 认</el-button
            >
        </div>
    </el-drawer>
</template>

<script>
const defaultData = {  
    adjustSellNum: 0
}
export default {
    data(){
        return{
            drawerShow: false,
            btnLoading: false,
            formDatas:{
                ...defaultData
            },
            rules:{
                adjustSellNum:[{ required: true, message: "请填写调整数量",trigger:"change"}]
            },
            total:0,
            itemData: null
        }
    },
    methods:{
        close(){
            this.$refs.formDatas.resetFields();
            this.drawerShow = false;
            this.formDatas = {
                ...defaultData
            }
        },
        show(data){
            this.itemData = data;	
            this.formDatas.adjustSellNum = data.adjustSellNum || 0;		
            this.drawerShow = true;
        },
       
        //表单提交
        submitForm() {			
            this.$refs["formDatas"].validate((valid) => {
                if (valid) {
                    this.btnLoading = true;    
                    this.$request({
                        url: '/activity/adjustSellNum',
                        data: {
                            activityId:this.itemData.activityId,
                            ticketPriceId: this.itemData.id,
                            adjustSellNum: this.formDatas.adjustSellNum
                        },
                        method: "post",
                    })
                        .then((res) => {
                            const { state, msg } = res.data;
                            if (state == 1) {
                                this.$emit("onUpdate");
                                this.close();
                            } else {
                                this.$message.error(msg || "操作失败,请重试");
                            }
                        })
                        .catch(() => {
                            self.$message.error("操作失败,请重试");
                        })
                        .finally(() => {
                            this.btnLoading = false;
                        });   
                } else {
                    return false;
                }
            });
        },
    }
}
</script>
<style lang="scss" scoped>
	.lineH25{
		line-height: 25px;
		margin-top: 20px;
	}
</style>